import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Payday} from "../../../Payday";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


/**
 * Created by jonas on 2022-01-12.
 */

export class BrokeBankPresentation implements SimplePresentation {

    name:string = "BrokeBankPresentation";

    constructor() {
    }



    shouldRun():boolean {
        return Payday.model.gameData.brokeTheBank;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            controller.setSkipCallback();
            Payday.keypadPlugin.setZeroBetSpinCounter(-1);
            Payday.soundPlayer.fadeOutMusic();
            Payday.keypadPlugin.setWin(Payday.model.gameData.accumulatedRoundWin,
                                           Payday.model.data.mode != GameMode.NORMAL,
                                           Payday.isWinBelowStake()); // what
        })
        tl.add(Payday.soundPlayer.playSoundBased("maxWinIntro"));
        tl.add(Payday.transitionScreen.showMaxWin());
        tl.add(() => {
            Payday.soundPlayer.playLoopingSound("winCapLoop");
        }, '<1.3')
        tl.add(Payday.transitionScreen.enableButton(() => this.onButtonClick(controller)), '>1.1');
     }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            Payday.soundPlayer.switchMusic(GameMode.NORMAL)
            Payday.keypadPlugin.setWin(Payday.model.data.accumulatedRoundWin,
                                           Payday.model.data.mode != GameMode.NORMAL,
                                           Payday.isWinBelowStake());
            Payday.reelView.setToNormal();
            Payday.soundPlayer.fadeInMusic();
            Payday.soundPlayer.stopSound("winCapLoop");
        })
        tl.add(Payday.backgroundElements.setToBaseGame());
        tl.add(Payday.transitionScreen.hideMaxWin());
        tl.add(() => controller.finish());

    }
}